import { render } from "./InputOptionsAbstract.vue?vue&type=template&id=dd2baf1a"
import script from "./InputOptionsAbstract.vue?vue&type=script&lang=js"
export * from "./InputOptionsAbstract.vue?vue&type=script&lang=js"

import exportComponent from "/Users/adrianfraczak/Projects/Actual/GC/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__